import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50" id="about">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <span className="inline-block text-xs font-medium text-accent-600 uppercase tracking-wider mb-3">
              What Is Kakobuy Spreadsheet
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-5">
              Your Ultimate <span className="text-primary-500">Kakobuy Spreadsheet</span> Resource for Smarter Shopping
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              A <strong>Kakobuy Spreadsheet</strong> is a meticulously curated, regularly updated document that brings together verified product finds, trusted seller profiles, quality control checklists, and comprehensive buying guides — all in one accessible format. Whether you are a seasoned Kakobuy shopper or just getting started, our spreadsheet eliminates the guesswork and helps you shop with confidence.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Every product recommendation in our <strong>Kakobuy Spreadsheet</strong> is reviewed based on seller reputation, quality checks, pricing analysis, and real buyer feedback. We do the heavy lifting so you can focus on finding exactly what you want without worrying about scams or low-quality items.
            </p>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Explore the Spreadsheet
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
              <Link
                to="/guide"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-700 text-sm font-medium rounded-lg hover:border-foreground-400 hover:text-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                How to Use It
                <i className="ri-book-open-line text-sm"></i>
              </Link>
            </div>
          </div>

          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20minimalist%20product%20photography%20scene%20featuring%20a%20crisp%20white%20t-shirt%20neatly%20folded%20beside%20a%20pair%20of%20classic%20retro%20sneakers%20and%20a%20woven%20straw%20hat%20all%20placed%20on%20a%20light%20oak%20wooden%20table%20surface%20warm%20natural%20sunlight%20streaming%20from%20an%20adjacent%20window%20creating%20soft%20highlights%20clean%20editorial%20aesthetic%20with%20organic%20texture%20and%20airy%20composition&width=800&height=600&seq=about-v2-kakobuy-002&orientation=landscape"
                alt="Curated Kakobuy Spreadsheet products"
                className="w-full h-full object-cover rounded-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}